import React from "react";
import bgImg from "../../../assets/Rectangle04.png";

const eligibilityCards = [
  {
    number: "01",
    text: (
      <>
        Had{" "}
        <span className="text-[#0A1F8F] font-bold">
          hernia mesh implant surgery
        </span>
      </>
    ),
    bg: "bg-[#FDF9ED]",
  },
  {
    number: "02",
    text: (
      <>
        Experienced{" "}
        <span className="text-[#0A1F8F] font-bold">
          complications or required revision surgery
        </span>
      </>
    ),
    bg: "bg-[#F3F4F9]",
  },
  {
    number: "03",
    text: (
      <>
        Have{" "}
        <span className="text-[#0A1F8F] font-bold">
          supporting medical records
        </span>
      </>
    ),
    bg: "bg-[#F3F4F9]",
  },
  {
    number: "04",
    text: (
      <>
        Are within the{" "}
        <span className="text-[#0A1F8F] font-bold">
          legal filing deadline
        </span>
      </>
    ),
    bg: "bg-[#FDF9ED]",
  },
];

const mobileEligibilityCards = eligibilityCards.map((card, index) => {
  return index % 2 === 0
    ? { ...card, bg: "!bg-[#FDF9ED]" }
    : { ...card, bg: "!bg-[#F3F4F9]" };
});

export default function EligibilityCriteria() {
  return (
    <section
      className="w-full bg-white py-12 font-[Quicksand] bg-cover"
      style={{ backgroundImage: `url(${bgImg})` }}
    >

      {/* Desktop / Laptop */}
      <div className="hidden lg:block max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="flex gap-6 xl:gap-8">

          {/* Left Content */}
          <div className="flex flex-col justify-center w-[43.61%]">
            <h2 className="text-[#0A1F8F] text-[30px] xl:text-[36px] font-semibold leading-tight mb-3">
              You <span className="text-[#EDC14A]">May Qualify</span> To File A Lawsuit If You…
            </h2>

            <p className="text-[#757575] text-[16px] xl:text-[18px] leading-[24px] font-medium">
              If you are unsure whether you qualify,{" "}
              submit the form above for a free case review.
            </p>
          </div>

          {/* Cards */}
          <div className="w-[56.39%] grid grid-cols-2 gap-6 xl:gap-7">
            {eligibilityCards.map((card) => (
              <article
                key={card.number}
                className={`flex flex-col justify-center items-start gap-2 p-6 xl:p-8 h-[150px] rounded-[10px] ${card.bg} shadow-sm border border-white`}
              >
                <span className="text-[#0A1F8F] text-[28px] xl:text-[32px] font-normal">
                  {card.number}
                </span>

                <p className="text-[#0A1F8F] text-[15px] font-medium leading-[22px] text-left">
                  {card.text}
                </p>
              </article>
            ))}
          </div>

        </div>
      </div>

      {/* Tablet */}
      <div className="hidden md:flex lg:hidden max-w-[1200px] mx-auto flex-col items-center gap-6 px-4 py-2">

        <div className="w-full text-center">
          <h2 className="text-[#0A1F8F] text-[28px] font-semibold leading-normal">
            You <span className="text-[#EDC14A]">May Qualify</span> To File A Lawsuit If You…
          </h2>

          <p className="text-[#757575] text-[15px] font-medium mt-4 leading-[22px]">
            If you are unsure whether you qualify,{" "}
            submit the form above for a free case review.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-8">
          {eligibilityCards.map((card) => (
            <article
              key={card.number}
              className={`flex flex-col justify-center items-start gap-3 p-6 h-[150px] rounded-[10px] ${card.bg} shadow-sm border border-white`}
            >
              <span className="text-[#0A1F8F] text-[26px] font-normal">
                {card.number}
              </span>

              <p className="text-[#0A1F8F] text-[15px] font-medium leading-[22px]">
                {card.text}
              </p>
            </article>
          ))}
        </div>
      </div>

      {/* Mobile */}
      <div className="md:hidden flex flex-col items-center gap-6 px-4">

        <h2 className="text-[#0A1F8F] text-[24px] font-semibold leading-snug text-left w-full">
          You <span className="text-[#EDC14A]">May Qualify</span> To File A Lawsuit If You…
        </h2>

        <p className="text-[#757575] text-[14px] font-medium leading-[22px] text-left">
          If you are unsure whether you qualify,{" "}
          submit the form above for a free case review.
        </p>

        <div className="flex flex-col gap-5 w-full max-w-[360px]">
          {mobileEligibilityCards.map((card) => (
            <article
              key={card.number}
              className={`flex flex-col gap-3 p-5 rounded-[10px] ${card.bg} shadow-sm border border-white`}
            >
              <span className="text-[#0A1F8F] text-[30px] font-normal">
                {card.number}
              </span>

              <p className="text-[#0A1F8F] text-[15px] font-medium leading-[22px]">
                {card.text}
              </p>
            </article>
          ))}
        </div>

      </div>

    </section>
  );
}